import reqProvider from '../coreRequests';
import { SEARCH_API } from '../urlPaths';
import { getToken } from 'config/lib';
import { iInterpreterResult } from 'store/types/interpreter';
import { SagaIterator } from 'redux-saga';
import { AxiosRequestHeaders } from 'axios';
import { call } from 'redux-saga/effects';

export function* interpretBomInput(bomData: any[]): SagaIterator{
  const token = getToken();
  const requestPath = `${SEARCH_API}/interpreter`;
  const headers: AxiosRequestHeaders = {
    'Content-Type': 'application/json', Authorization: `Bearer ${token}`
  };

  try {
  const response = yield call(reqProvider.postReq, requestPath, headers, {bomData: {bomData}});
  return response.data as iInterpreterResult;

    }
    catch (error) {
      console.error("Error in postAssembly:", error);
      return null;
    }
}

export default {
    interpretBomInput,
}